"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERegisterOrAuthorizeEnhancedStatus = void 0;
exports.getBrokenContractResponse = getBrokenContractResponse;
exports.transform200 = transform200;
exports.transform400 = transform400;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("../../repositories/users/v2/register-or-authorize-user/types");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
let ERegisterOrAuthorizeEnhancedStatus = exports.ERegisterOrAuthorizeEnhancedStatus = /*#__PURE__*/function (ERegisterOrAuthorizeEnhancedStatus) {
  /** Удачно **/
  ERegisterOrAuthorizeEnhancedStatus["Success"] = "success";
  /** Код введён некорректно **/
  ERegisterOrAuthorizeEnhancedStatus["Wrong"] = "wrong";
  /** Необходимо ввести пароль **/
  ERegisterOrAuthorizeEnhancedStatus["CheckPassword"] = "checkPassword";
  /** Превышен лимит ввода кода **/
  ERegisterOrAuthorizeEnhancedStatus["CodeInputLimitReached"] = "codeInputLimitReached";
  /** Истекло время действия проверочного кода **/
  ERegisterOrAuthorizeEnhancedStatus["CodeExpired"] = "codeExpired";
  /** Множество аккаунтов **/
  ERegisterOrAuthorizeEnhancedStatus["ManyAccounts"] = "manyAccounts";
  /** Нарушен контракт */
  ERegisterOrAuthorizeEnhancedStatus["BrokenContract"] = "brokenContract";
  /** Ошибка */
  ERegisterOrAuthorizeEnhancedStatus["Error"] = "error";
  return ERegisterOrAuthorizeEnhancedStatus;
}({});
function getBrokenContractResponse(response) {
  return {
    status: ERegisterOrAuthorizeEnhancedStatus.BrokenContract,
    originalResponse: response
  };
}
function transform200(response) {
  const {
    status,
    users,
    isRegistered,
    temporaryToken,
    token,
    logOnUrl
  } = response;
  switch (status) {
    case _types.EStatus.Success:
      if (users.length === 0 || !token || !logOnUrl) {
        return getBrokenContractResponse(response);
      }
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.Success,
        email: users[0].email,
        token,
        logOnUrl,
        isRegistered: Boolean(isRegistered)
      };
    case _types.EStatus.ManyAccounts:
      if (!temporaryToken || users.length === 0) {
        return getBrokenContractResponse(response);
      }
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.ManyAccounts,
        accounts: users,
        phoneАccounts: users.filter(user => user.phone),
        temporaryToken
      };
    case _types.EStatus.CodeExpired:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CodeExpired
      };
    case _types.EStatus.CheckPassword:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CheckPassword
      };
    case _types.EStatus.CodeInputLimitReached:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.CodeInputLimitReached
      };
    case _types.EStatus.Wrong:
      return {
        status: ERegisterOrAuthorizeEnhancedStatus.Wrong
      };
    default:
      return getBrokenContractResponse(response);
  }
}
function transform400(response) {
  return _objectSpread({
    status: ERegisterOrAuthorizeEnhancedStatus.Error
  }, response);
}